export default __webpack_public_path__ + "static/media/trovityCard.ad981107.svg";